import { useCallback, useContext } from "react";
import { ACCOUNT_PROVIDERS } from "@letsbit/malcolmlb";
import { defineMessages, useIntl } from "react-intl";
import { ApiContext } from "providers/ApiProvider";
import { useNotification } from "hooks/utils/useNotification";
import { NotificationStatus } from "components/Notification/types";

const FILE_NAME = "Comprobante de cupon ";

const scope = "hooks.useDownloadAlpacaDocument";

const messages = defineMessages({
  errorFileDownloadDescription: {
    id: `${scope}.errorFileDownloadDescription`,
    defaultMessage: "Ocurrió un error durante la descarga",
  },
  fileDownloadTitle: {
    id: `${scope}.fileDownloadTitle`,
    defaultMessage: "Descarga",
  },
  successFileDownloadDescription: {
    id: `${scope}.successFileDownloadDescription`,
    defaultMessage: "El archivo fue descargado exitosamente",
  },
});

export const useDownloadDocumentMerk = () => {
  const intl = useIntl();
  const { memberInstance } = useContext(ApiContext);
  const { showNotification } = useNotification();

  const downloadDocument = useCallback(
    async (document_id: string, provider_id: ACCOUNT_PROVIDERS) => {
      try {
        const response = await memberInstance.merk.downloadDocument({
          document_id,
          provider_id,
        });

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", FILE_NAME + document_id + ".pdf"); // You can customize the file name here
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(url);

        showNotification({
          status: NotificationStatus.SUCCESS,
          title: intl.formatMessage(messages.fileDownloadTitle),
          message: intl.formatMessage(messages.successFileDownloadDescription),
        });
      } catch (error) {
        showNotification({
          status: NotificationStatus.SUCCESS,
          title: intl.formatMessage(messages.fileDownloadTitle),
          message: intl.formatMessage(messages.errorFileDownloadDescription),
        });
      }
    },
    [memberInstance.merk, showNotification, intl],
  );

  return { downloadDocument };
};
